module.exports = __webpack_public_path__ + "img/mir.f552fba.svg";